import * as React from 'react';
import style from './categories-box.scss';
import { Box, Text, TextButton } from 'wix-style-react';
export var CategoriesBox = function (_a) {
    var solution = _a.solution, onCategoryClick = _a.onCategoryClick, onSubCategoryClick = _a.onSubCategoryClick;
    var _b = getCategoryAndSub(solution), subCategory = _b.subCategory, category = _b.category;
    return category ? (React.createElement("div", { className: style.categories },
        React.createElement(TextButton, { size: "tiny", onClick: function (e) { return onCategoryClick(e, category); } }, category.name),
        React.createElement(Box, { margin: "0 6px" },
            React.createElement(Text, { size: "small" }, "/")),
        React.createElement(TextButton, { size: "tiny", onClick: function (e) { return onSubCategoryClick(e, category, subCategory); } }, subCategory.name))) : (React.createElement(React.Fragment, null));
};
var getCategoryAndSub = function (solution) {
    var _a, _b, _c;
    if (((_a = solution === null || solution === void 0 ? void 0 : solution.Tags) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        var subCategory_1 = (_b = solution === null || solution === void 0 ? void 0 : solution.Tags) === null || _b === void 0 ? void 0 : _b.find(function (tag) { return tag === null || tag === void 0 ? void 0 : tag.parentSlug; });
        var category = subCategory_1
            ? (_c = solution === null || solution === void 0 ? void 0 : solution.Tags) === null || _c === void 0 ? void 0 : _c.find(function (tag) { return (tag === null || tag === void 0 ? void 0 : tag.slug) === (subCategory_1 === null || subCategory_1 === void 0 ? void 0 : subCategory_1.parentSlug); }) : null;
        return { subCategory: subCategory_1, category: category };
    }
    return {};
};
//# sourceMappingURL=index.js.map